@if (metadata) {
    <div class="badge rounded-pill d-flex align-items-center text-nowrap gap-2"
         [ngClass]="badgeClass">
        <i class="fal fa-fw badge-icon"></i>
        {{ metadata!.name }}
        @if (showRightChevronDown) {
            <i class="fal fa-chevron-down"></i>
        }
        @if (showRightChevronUp) {
            <i class="fal fa-chevron-up"></i>
        }
    </div>
}
